import { Billing } from 'containers/Billing'

export default Billing
